import { CostTypes } from '@bmai/shared';
import type { LicenseCostRecord } from './LicensesApiService';

/** Whether the record is a flat seat/subscription cost per its `cost_type` dimension.
 *  Provider-api (metered) records rarely carry the tag, so untagged means usage. */
export function isSubscriptionCost(record: LicenseCostRecord): boolean {
    const dims: Record<string, unknown> = record.dimensions ?? {};
    return dims['cost_type'] === CostTypes.subscription;
}

/** Admin/subscription entries carry their context in free-form dimensions
 *  (description, seat_count) rather than model/SKU/workspace columns. */
export function rawDescription(record: LicenseCostRecord): string | null {
    const dims: Record<string, unknown> = record.dimensions ?? {};
    return typeof dims['description'] === 'string' && dims['description'].length > 0 ? dims['description'] : null;
}

/** The recorded seat count, when the manual entry included one. */
export function recordSeatCount(record: LicenseCostRecord): number | null {
    const dims: Record<string, unknown> = record.dimensions ?? {};
    return typeof dims['seat_count'] === 'number' ? dims['seat_count'] : null;
}

/** Display form: the description with the seat count appended when recorded. */
export function recordDescription(record: LicenseCostRecord): string | null {
    const description = rawDescription(record);
    const seats = recordSeatCount(record);
    if (description === null && seats === null) return null;
    return [description, seats !== null ? `${seats} seats` : null].filter((part): part is string => part !== null).join(' · ');
}
